<template>
    <v-dialog v-model="dialogSwitch" persistent scrollable width="1000">
        <v-card class="full-card overflow-y-auto" elevation="3">
            <v-card-title id="heading" class="d-flex justify-space-between">
                <h3>Add Device</h3>
                <v-btn
                    density="compact"
                    icon="mdi-close"
                    variant="flat"
                    @click="$emit('update:modelValue', false)"
                />
            </v-card-title>
            <v-divider/>
            <v-card-text class="py-0 text-start">
                <v-data-table
                    v-model="selectedDevices"
                    :headers="headers"
                    :items="devices"
                    item-value="id"
                    show-select
                ></v-data-table>
            </v-card-text>
            <v-card-actions class="px-4 d-flex justify-end">
                <v-btn size="small" type="button" @click="$emit('update:modelValue', false)">
                    Close
                </v-btn>
                <v-btn :disabled="!devices.length || !selectedDevices.length" color="blue"
                       size="small"
                       @click="linkDevices">Add
                    Device
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script setup>
import {ref} from "vue";
import {send} from "@/composables/apiClient";
import {useSnackbarStore} from "@/stores/snackBarStore";

const props = defineProps({
    modelValue: Boolean,
    group: Object,
    devices: Array,
    selectedDevices: Array
});

const snackbar = useSnackbarStore();
const emits = defineEmits(["update:modelValue", "updateDevice"]);
const selectedDevices = ref(props.selectedDevices || []);
const dialogSwitch = ref(props.modelValue);
const headers = ref([
    {title: "Serial No.", key: "slno", sortable: true, align: "left"}
]);

const linkDevices = () => {
    send('post', `device-groups/${props.group.id}/devices`, {devices: selectedDevices.value})
        .then((res) => {
            snackbar.showSnackbar('Devices linked successfully', 'success');
            emits('updateDevice', res);
            emits('update:modelValue', false);
        })
        .catch((error) => {
            console.log(error)
            snackbar.showSnackbar(error.response?.data.message, 'error');
        });
}
</script>
